<script>
    import { goBack, store, triggerValidation } from '../../Store.svelte';
    import { onDestroy, onMount } from 'svelte';
    import { navigate } from 'svelte-routing';
    import {
        formValidation,
        personalDetailsFields,
    } from '../../Validators.svelte';
    import { isNegocios } from '../../Util.svelte';
    import Modal from '../../components/Modal.svelte';
    import {
        clientPurchaseCreate,
        clientAddOffers,
        clientPurchaseProcess,
    } from '../../clients/PurchaseClient.svelte';
    import { getStores, getStock } from '../../clients/StoreClient.svelte';
    import Preloader from '../../components/Preloader.svelte';
    import { getStockByBranch } from '../../components/comparator/utils/utils';
    import { CURRENT_STOCK_UNSELECTED } from '../../components/comparator/utils/constant';
    const isSky = $store.requestedServices.isSky;
    const tabsStyle = `--dynamic-rgba: ${isSky ? 'rgba(4, 8, 255, 0.342)' : 'rgba(211, 23, 114, 0.1)'};
                       --dynamic-color: ${isSky ? '#000ff5' : '#d31772'};`;
    let storeStock = null;
    if ($store.requestedServices.productId == null) {
        navigate('/comparador', { replace: false });
    }

    if ($store.personalDetails.nombre == null) {
        navigate('/compra/datos', { replace: false });
    }

    if ($store.requestedAddress.postalCode == '') {
        navigate('/comparador', { replace: false });
    }
    let branchList = [];
    let interval;
    let isDeliveryBranch = false;
    let isDeliveryDomiciliary = false;
    let isDeliveryTechnical = false;
    let selectedBranch = '';
    let branchError = false;
    let processAdvanced = !!$store.purchaseStatus.accountNumber;
    $: showLoaderStock = false;
    $: selectedBranchStock = CURRENT_STOCK_UNSELECTED;
    $: showAutoinstallationFields = $store.requestedServices.autoinstalacion;
    $: showAddressFields =
        (!isDeliveryBranch && isDeliveryDomiciliary) ||
        !showAutoinstallationFields;
    $: showTechnicianAddressFields = isDeliveryTechnical;

    $: if (
        $store.requestedServices.deliveryType === 'SUCURSAL' &&
        branchList.length &&
        $store?.requestedServices?.sucursalId
    ) {
        const sucursalId = $store.requestedServices.sucursalId;
        const exists = branchList.find(
            (branch) => branch.idsucursal == sucursalId
        );
        if (exists) {
            selectedBranch = sucursalId;
        }
    }
    let isLoadingStock = true;
    let isLoadingStores = true;
    let limpiarDireccionFacturacion = (allData) => {
        delete allData.billing;
        delete allData.billingPostalCode;
        delete allData.billingCity;
        delete allData.billingSettlement;
        delete allData.billingStreet;
        delete allData.billingExteriorNumber;
        delete allData.billingInteriorNumber;
        delete allData.billingState;
        $store.requestedAddress.billing = false;
        $store.requestedAddress.billingPostalCode = '';
        $store.requestedAddress.billingCity = '';
        $store.requestedAddress.billingSettlement = '';
        $store.requestedAddress.billingStreet = '';
        $store.requestedAddress.billingExteriorNumber = '';
        $store.requestedAddress.billingInteriorNumber = '';
        $store.requestedAddress.billingState = '';
    };

    if (!$store.requestedServices.autoinstalacion) {
        $store.requestedServices.deliveryType = 'DOMICILIO';
        $store.requestedServices.flagAutoinstalacion = false;
    }

    async function valContent() {
        if (processAdvanced) {
            if (
                $store.requestedServices.deliveryType === 'SUCURSAL' ||
                $store.requestedServices.deliveryType === 'DOMICILIO'
            ) {
                navigate('/compra/info', { replace: false });
            } else if ($store.requestedServices.deliveryType === 'TECNICO') {
                navigate('/compra/fecha', { replace: false });
            }
        }
        if (isDeliveryBranch) {
            branchError = selectedBranch === '';
            if (!branchError) {
                loading = true;
                $store.requestedServices.sucursalId = selectedBranch;
                $store.requestedAddress.branch = selectedBranch;
                if (
                    $store.purchaseStatus.processId == null ||
                    $store.purchaseStatus.processId.length == 0
                ) {
                    await processPurchase();
                } else {
                    if ($store.purchaseStatus.accountId == null) {
                        checkPurchase();
                    } else {
                        if (isDeliveryBranch) {
                            navigate('/compra/info', { replace: false });
                        } else if (
                            isDeliveryDomiciliary ||
                            isDeliveryTechnical ||
                            !$store.requestedServices.autoinstalacion
                        ) {
                            navigate('/compra/fecha', { replace: false });
                        }
                    }
                }
                return;
            }
            return;
        }

        let allData = { ...$store.personalDetails, ...$store.requestedAddress };
        if (!isNegocios($store.requestedServices.product.productFamily)) {
            delete allData.giroNegocio;
        }

        if (!$store.personalDetails.billing) {
            delete allData.rfc;
            delete allData.codigoCfdi;
            delete allData.regimenFiscal;
            $store.personalDetails.codigoCfdi = '';
            $store.personalDetails.regimenFiscal = '';
            $store.personalDetails.rfc = '';
            limpiarDireccionFacturacion(allData);
            valField('rfc');
        } else {
            if (!$store.requestedAddress.billing) {
                limpiarDireccionFacturacion(allData);
            } else {
                valField('billingStreet');
            }
        }

        let valid = formValidation(fields, allData, null);
        if (valid) {
            loading = true;
            if (
                $store.purchaseStatus.processId == null ||
                $store.purchaseStatus.processId.length == 0
            ) {
                await processPurchase();
            } else {
                if ($store.purchaseStatus.accountId == null) {
                    checkPurchase();
                } else {
                    goToNextStep();
                }
            }
        }
    }

    $: messageInfoError = 'Error interno';
    function checkPurchase() {
        var attempts = 0;
        interval = setInterval(() => {
            try {
                clientPurchaseProcess($store.purchaseStatus.processId).then(
                    (response) => {
                        if (response.code == 500) {
                            MicroModal.show('modalError');
                        }
                        if (response.statusCode == 0) {
                            clearInterval(interval);
                            $store.purchaseStatus.status = '';
                            $store.purchaseStatus.processId = '';
                            messageInfoError = response.status;
                            loading = false;
                            MicroModal.show('modalError');
                        } else {
                            $store.purchaseStatus.status = response.lastAction;
                            if (response.status === 'PURCHASE_01WP') {
                                $store.purchaseStatus.accountId =
                                    response.accountId;
                                $store.purchaseStatus.accountNumber =
                                    response.accountNumber;
                                $store.purchaseStatus.accountNumber10D =
                                    response.accountNumber10D;
                                $store.purchaseStatus.orderNumber =
                                    response.orderNumber;
                                $store.purchaseStatus.rptEliminaPagoAnticipado =
                                    response.rptEliminaPagoAnticipado;
                                clearInterval(interval);
                                goToNextStep();
                            }
                        }
                    }
                );
            } catch (err) {
                console.log(err);
            }
            attempts += 1;
            if (attempts > 100) {
                console.log('enough attempts');
                clearInterval(interval);
            }
        }, 10000);
    }

    async function checkPurchaseStatus() {
        return new Promise((resolve, reject) => {
            var attempts = 0;
            let interval = setInterval(async () => {
                try {
                    let response = await clientPurchaseProcess(
                        $store.purchaseStatus.processId
                    );

                    if (response.code == 500) {
                        MicroModal.show('modalError');
                        clearInterval(interval);
                        reject(new Error('Error en la compra'));
                    }

                    if (response.statusCode == 0) {
                        clearInterval(interval);
                        $store.purchaseStatus.status = '';
                        $store.purchaseStatus.processId = '';
                        messageInfoError = response.status;
                        loading = false;
                        MicroModal.show('modalError');
                        reject(new Error('Error en el proceso de compra'));
                    } else {
                        $store.purchaseStatus.status = response.lastAction;

                        if (response.status === 'PURCHASE_03WP') {
                            $store.purchaseStatus.accountId =
                                response.accountId;
                            $store.purchaseStatus.accountNumber =
                                response.accountNumber;
                            $store.purchaseStatus.accountNumber10D =
                                response.accountNumber10D;
                            $store.purchaseStatus.orderNumber =
                                response.orderNumber;
                            $store.purchaseStatus.rptEliminaPagoAnticipado =
                                response.rptEliminaPagoAnticipado;

                            clearInterval(interval);
                            resolve();
                        }
                    }
                } catch (err) {
                    console.log(err);
                    clearInterval(interval);
                    reject(err);
                }

                attempts += 1;
                if (attempts > 100) {
                    console.log('enough attempts');
                    clearInterval(interval);
                    reject(new Error('Tiempo de espera agotado'));
                }
            }, 10000);
        });
    }

    onMount(async () => {
        window.document.dispatchEvent(
            new Event('DOMContentLoaded', {
                bubbles: true,
                cancelable: true,
            })
        );
        $store.settings.location = { progress: 55, step: 3 };

        try {
            if ($store.requestedServices.autoinstalacion) {
                const stores = await getStores(
                    $store.requestedAddress.latitude,
                    $store.requestedAddress.longitude
                );
                if (stores.branchOffices.length > 0) {
                    branchList = stores.branchOffices.filter(
                        (branch) => branch.distanceInKm <= 15
                    );
                }
                isLoadingStores = false;
                storeStock = await getStock();
                isLoadingStock = false;
            }
        } catch (error) {
            console.error('Error fetching stores:', error);
        }
    });

    onDestroy(() => clearInterval(interval));

    function backHandler() {
        let izzimovilPlan = $store.requestedServices.izzimovil.plan;
        if (izzimovilPlan != null && izzimovilPlan.offerId != null) {
            navigate('/compra/entrega', { replace: false });
        } else {
            navigate('/compra/datos', { replace: false });
        }
    }

    let valField = (fieldName) => {
        let allData = { ...$store.personalDetails, ...$store.requestedAddress };
        formValidation(fields, allData, fieldName);
        fields = fields;
    };

    $: validContinue = $store.requestedServices.deliveryType !== '';

    function setDeliveryType(type) {
        $store.requestedServices.deliveryType = type;
        if (type === 'SUCURSAL') {
            $store.requestedServices.deliveryType = 'SUCURSAL';
            $store.requestedServices.flagAutoinstalacion = true;
            $store.requestedAddress.betweenStreets1 = 'Sin Referencia';
            $store.requestedAddress.betweenStreets2 = 'Sin Referencia';
            $store.requestedAddress.addressReference = 'Sin Referencia';
        } else if (type === 'DOMICILIO') {
            $store.requestedServices.deliveryType = 'DOMICILIO';
            $store.requestedServices.flagAutoinstalacion = true;
            $store.requestedAddress.betweenStreets1 = '';
            $store.requestedAddress.betweenStreets2 = '';
            $store.requestedAddress.addressReference = '';
        } else if (type === 'TECNICO') {
            $store.requestedServices.deliveryType = 'TECNICO';
            $store.requestedServices.flagAutoinstalacion = false;
            $store.requestedAddress.betweenStreets1 = '';
            $store.requestedAddress.betweenStreets2 = '';
            $store.requestedAddress.addressReference = '';
        }
    }

    function goToNextStep() {
        if ($store.requestedServices.flagAutoinstalacion) {
            navigate('/compra/info', { replace: false });
        } else {
            navigate('/compra/fecha', { replace: false });
        }
    }

    async function processPurchase() {
        await clientPurchaseCreate($store)
            .then(async (response) => {
                if (response.message) {
                    messageInfoError = messageInfoError =
                        '409 error: ' +
                        (response.message != undefined ? response.message : '');
                    loading = false;
                    MicroModal.show('modalError');
                } else {
                    $store.purchaseStatus.processId = response;
                }
            })
            .catch((error) => {
                console.log(error);
                messageInfoError =
                    error.message != undefined ? error.message : '';
                loading = false;
                MicroModal.show('modalError');
            });

        await checkPurchaseStatus();

        await clientAddOffers($store.purchaseStatus.processId, $store)
            .then((status) => {
                if (status !== 200) {
                    messageInfoError = `Error ${status}: ${
                        status === 409
                            ? 'Conflicto en la solicitud'
                            : 'Ocurrió un error inesperado'
                    }`;
                    loading = false;
                    MicroModal.show('modalError');
                } else {
                    checkPurchase();
                }
            })
            .catch((error) => {
                console.log(error);
                messageInfoError = error.message || 'Error desconocido';
                loading = false;
                MicroModal.show('modalError');
            });
    }

    let facturar = () => {
        window.document.dispatchEvent(
            new Event('DOMContentLoaded', {
                bubbles: true,
                cancelable: true,
            })
        );
    };

    let facturaDireccion = () => {
        window.document.dispatchEvent(
            new Event('DOMContentLoaded', {
                bubbles: true,
                cancelable: true,
            })
        );
    };

    $: loading = false;

    let fields = personalDetailsFields;

    $: isNextStepDisabled = processAdvanced
        ? false
        : loading ||
          ((isDeliveryBranch ||
              $store.requestedServices.deliveryType === 'SUCURSAL') &&
              (branchError ||
                  selectedBranchStock === 0 ||
                  !selectedBranch ||
                  selectedBranch === '' ||
                  selectedBranchStock === null ||
                  isLoadingStock ||
                  storeStock === 'Error fetching stock' ||
                  selectedBranchStock === CURRENT_STOCK_UNSELECTED));

    Object.values(fields).some((field) => field.error);

    $: {
        if ($goBack) {
            backHandler();
            goBack.set(false);
        }

        if ($triggerValidation) {
            valContent();
            triggerValidation.set(false);
        }
    }

    function delay(ms) {
        return new Promise((resolve) => setTimeout(resolve, ms));
    }

    async function waitForStockToLoad(maxRetries = 10, interval = 500) {
        let attempts = 0;
        while (isLoadingStock && attempts < maxRetries) {
            await delay(interval);
            attempts++;
        }
        if (isLoadingStock) {
            throw new Error('Stock loading timeout');
        }
    }
</script>

<div class="service-address">
    <div class="pure-g justify-content-center {loading ? '' : 'hide'}">
        <div class="pure-g">
            <div class="pure-u-1">
                <div class="text-center">
                    <Preloader
                        status={!$store.requestedServices.flagAutoinstalacion
                            ? 'Estamos buscando la mejor fecha para tu instalación. \n Un momento, por favor.'
                            : 'Estamos procesando tu información. \n Un momento, por favor.'}
                    />
                </div>
            </div>
        </div>
    </div>
    <div class="pure-g justify-content-center {!loading ? '' : 'hide'}">
        <div class="pure-u-1">
            <div class="pure-u-1 m-b-20">
                <h1 class="text-fs-26">Ingresa la dirección de instalación</h1>
            </div>
            <div class="panel m-b-30">
                <div class="d-flex justify-content-between flex-wrap">
                    {#if $store.requestedServices.autoinstalacion}
                        <div class="d-flex justify-content-between flex-wrap">
                            <div>
                                <p class="fw-semibold m-b-25">
                                    Autoinstalación
                                </p>
                                <p>
                                    Recibe tu equipo en casa o recógelo en
                                    sucursal y configúralo fácilmente por tu
                                    cuenta.
                                </p>
                            </div>
                        </div>
                    {/if}
                    {#if showAddressFields && !$store.requestedServices.autoinstalacion}
                        <p class="fw-semibold m-b-10 m-t-16">
                            Dirección de envío
                        </p>
                        <p>
                            Esta dirección corresponde a la misma ubicación que
                            indicaste al iniciar tu contratación
                        </p>
                        <div class="pure-g align-items-center m-b-20">
                            <div class="pure-u-1 pure-u-sm-1-3">
                                <div
                                    class="ctrl-holder m-b-20 {fields.street
                                        .error
                                        ? 'error'
                                        : ''}"
                                >
                                    <label
                                        for="street"
                                        class="placeholder placeholder-filled disabled"
                                        >Calle</label
                                    >
                                    <input
                                        type="text"
                                        readonly={$store.requestedAddress
                                            .addressId !== ''}
                                        name="street"
                                        id="street"
                                        required
                                        disabled={true}
                                        on:input={() => valField('street')}
                                        bind:value={
                                            $store.requestedAddress.street
                                        }
                                    />
                                    {#if fields.street.error}
                                        <label class="error" for="street"
                                            >{fields.street.errorMessage}</label
                                        >
                                    {/if}
                                </div>
                            </div>
                            <div class="pure-u-1-2 pure-u-sm-1-3 pure-u-md-1-6">
                                <div
                                    class="ctrl-holder m-b-20 {fields
                                        .externalNumber.error
                                        ? 'error'
                                        : ''}"
                                >
                                    <label
                                        for="externalNumber"
                                        class="placeholder placeholder-filled disabled"
                                        >No. Ext</label
                                    >
                                    <input
                                        type="text"
                                        name="externalNumber"
                                        disabled={true}
                                        id="externalNumber"
                                        required
                                        bind:value={
                                            $store.requestedAddress
                                                .externalNumber
                                        }
                                        on:input={() =>
                                            valField('externalNumber')}
                                    />
                                    {#if fields.externalNumber.error}
                                        <label
                                            class="error"
                                            for="externalNumber"
                                            >{fields.externalNumber
                                                .errorMessage}</label
                                        >
                                    {/if}
                                </div>
                            </div>
                            <div class="pure-u-1-2 pure-u-sm-1-3 pure-u-md-1-6">
                                <div
                                    class="ctrl-holder m-b-20 {fields
                                        .internalNumber.error
                                        ? 'error'
                                        : ''}"
                                >
                                    <label
                                        for="internalNumber"
                                        class="placeholder placeholder-filled disabled"
                                        >No. Int</label
                                    >
                                    <input
                                        type="text"
                                        name="internalNumber"
                                        disabled={true}
                                        id="internalNumber"
                                        bind:value={
                                            $store.requestedAddress
                                                .internalNumber
                                        }
                                        on:input={() =>
                                            valField('internalNumber')}
                                    />
                                    {#if fields.internalNumber.error}
                                        <label
                                            class="error"
                                            for="internalNumber"
                                            >{fields.internalNumber
                                                .errorMessage}</label
                                        >
                                    {/if}
                                </div>
                            </div>
                            <div class="pure-u-1 pure-u-sm-1-3">
                                <div class="ctrl-holder m-b-20">
                                    <label
                                        for="zipCode"
                                        class="placeholder placeholder-filled disabled"
                                        >Código postal</label
                                    >
                                    <input
                                        type="text"
                                        readonly="true"
                                        disabled={true}
                                        name="postalCode"
                                        id="postalCode"
                                        required
                                        bind:value={
                                            $store.requestedAddress.postalCode
                                        }
                                    />
                                </div>
                            </div>
                            <div class="pure-u-1 pure-u-sm-1-2 pure-u-lg-1-3">
                                <div
                                    class="ctrl-holder m-b-20 {fields.suburb
                                        .error
                                        ? 'error'
                                        : ''}"
                                >
                                    <label
                                        for="suburb"
                                        class="placeholder placeholder-filled disabled"
                                        >Colonia</label
                                    >
                                    <input
                                        type="text"
                                        name="suburb"
                                        disabled={true}
                                        id="suburb"
                                        required
                                        bind:value={
                                            $store.requestedAddress.suburb
                                        }
                                        on:input={() => valField('suburb')}
                                    />
                                    {#if fields.suburb.error}
                                        <label class="error" for="suburb"
                                            >{fields.suburb.errorMessage}</label
                                        >
                                    {/if}
                                </div>
                            </div>
                            <div class="pure-u-1 pure-u-sm-1-2 pure-u-lg-1-3">
                                <div
                                    class="ctrl-holder m-b-20 {fields.state
                                        .error
                                        ? 'error'
                                        : ''}"
                                >
                                    <label
                                        for="state"
                                        class="placeholder placeholder-filled disabled"
                                        >Estado</label
                                    >
                                    <input
                                        type="text"
                                        name="state"
                                        disabled={true}
                                        id="state"
                                        required
                                        bind:value={
                                            $store.requestedAddress.state
                                        }
                                        on:input={() => valField('state')}
                                    />
                                    {#if fields.state.error}
                                        <label class="error" for="state"
                                            >{fields.state.errorMessage}</label
                                        >
                                    {/if}
                                </div>
                            </div>
                            <div class="pure-u-1 pure-u-sm-1-2 pure-u-lg-1-3">
                                <div
                                    class="ctrl-holder m-b-20 {fields.city.error
                                        ? 'error'
                                        : ''}"
                                >
                                    <label
                                        for="city"
                                        class="placeholder placeholder-filled disabled"
                                        >Delegación o municipio</label
                                    >
                                    <input
                                        type="text"
                                        name="city"
                                        disabled={true}
                                        id="city"
                                        required
                                        bind:value={
                                            $store.requestedAddress.city
                                        }
                                        on:input={() => valField('city')}
                                    />
                                    {#if fields.city.error}
                                        <label class="error" for="city"
                                            >{fields.city.errorMessage}</label
                                        >
                                    {/if}
                                </div>
                            </div>
                        </div>
                        <p class="fw-semibold m-b-10 m-t-16">Referencias</p>
                        <div class="pure-g align-items-center">
                            <div class="pure-u-1 pure-u-sm-1-2">
                                <div
                                    class="ctrl-holder m-b-20 {fields
                                        .betweenStreets1.error === true
                                        ? 'error'
                                        : ''}"
                                >
                                    <label
                                        for="betweenStreets1"
                                        class="placeholder placeholder-filled disabled"
                                        >Calle 1</label
                                    >
                                    <input
                                        type="text"
                                        name="betweenStreets1"
                                        id="betweenStreets1"
                                        disabled={processAdvanced}
                                        bind:value={
                                            $store.requestedAddress
                                                .betweenStreets1
                                        }
                                        on:input={() =>
                                            valField('betweenStreets1')}
                                    />
                                    {#if fields.betweenStreets1.error}
                                        <label
                                            class="error"
                                            for="betweenStreets1"
                                            >{fields.betweenStreets1
                                                .errorMessage}</label
                                        >
                                    {/if}
                                </div>
                            </div>
                            <div class="pure-u-1 pure-u-sm-1-2">
                                <div
                                    class="ctrl-holder m-b-20 {fields
                                        .betweenStreets2.error
                                        ? 'error'
                                        : ''}"
                                >
                                    <label
                                        for="betweenStreets2"
                                        class="placeholder placeholder-filled disabled"
                                        >Calle 2</label
                                    >
                                    <input
                                        type="text"
                                        name="betweenStreets2"
                                        id="betweenStreets2"
                                        disabled={processAdvanced}
                                        required
                                        bind:value={
                                            $store.requestedAddress
                                                .betweenStreets2
                                        }
                                        on:input={() =>
                                            valField('betweenStreets2')}
                                    />
                                    {#if fields.betweenStreets2.error}
                                        <label
                                            class="error"
                                            for="betweenStreets2"
                                            >{fields.betweenStreets2
                                                .errorMessage}</label
                                        >
                                    {/if}
                                </div>
                            </div>
                            <div class="pure-u-1 pure-u-sm-1-1">
                                <div
                                    class="ctrl-holder {fields.addressReference
                                        .error
                                        ? 'error'
                                        : ''}"
                                >
                                    <label
                                        for="addressReference"
                                        class="placeholder placeholder-filled disabled"
                                        >Referencia</label
                                    >
                                    <input
                                        type="text"
                                        name="addressReference"
                                        id="addressReference"
                                        disabled={processAdvanced}
                                        required
                                        on:input={() =>
                                            valField('addressReference')}
                                        bind:value={
                                            $store.requestedAddress
                                                .addressReference
                                        }
                                    />
                                    {#if fields.addressReference.error}
                                        <label
                                            class="error"
                                            for="addressReference"
                                            >{fields.addressReference
                                                .errorMessage}</label
                                        >
                                    {/if}
                                </div>
                            </div>
                        </div>
                    {/if}
                    {#if $store.requestedServices.autoinstalacion}
                        <div class="content-button">
                            <button
                                class="button-address {$store.requestedServices
                                    .deliveryType === 'SUCURSAL'
                                    ? 'selected'
                                    : ''}"
                                disabled={processAdvanced}
                                on:click={() => {
                                    isDeliveryTechnical = false;
                                    isDeliveryDomiciliary = false;
                                    isDeliveryBranch = true;
                                    setDeliveryType('SUCURSAL');
                                }}>entrega en sucursal</button
                            >
                            <button
                                class="button-address {$store.requestedServices
                                    .deliveryType === 'DOMICILIO'
                                    ? 'selected'
                                    : ''}"
                                disabled={processAdvanced}
                                on:click={() => {
                                    isDeliveryTechnical = false;
                                    isDeliveryBranch = false;
                                    isDeliveryDomiciliary = true;
                                    setDeliveryType('DOMICILIO');
                                }}>entrega a domicilio</button
                            >
                        </div>
                        {#if isDeliveryBranch || $store.requestedServices.deliveryType === 'SUCURSAL'}
                            <div class="pure-g align-items-center m-t-16">
                                <div class="pure-u-1">
                                    <h2 class="text-fs-18 m-b-15">
                                        Elige tu sucursal más cercana
                                    </h2>
                                    <div class="select-holder">
                                        <select
                                            name="branch"
                                            id="branch"
                                            class="select-branch {branchError
                                                ? 'error'
                                                : ''}"
                                            disabled={processAdvanced}
                                            required
                                            bind:value={selectedBranch}
                                            on:change={async () => {
                                                branchError = false;
                                                showLoaderStock = true;
                                                try {
                                                    if (
                                                        storeStock ===
                                                        'Error fetching stock'
                                                    ) {
                                                        isLoadingStock = true;
                                                        showLoaderStock = true;
                                                        storeStock =
                                                            await getStock();
                                                        isLoadingStock = false;
                                                        showLoaderStock = false;
                                                    }
                                                    await waitForStockToLoad();
                                                    if (
                                                        storeStock &&
                                                        storeStock !==
                                                            'Error fetching stock'
                                                    ) {
                                                        selectedBranchStock =
                                                            getStockByBranch(
                                                                storeStock,
                                                                selectedBranch
                                                            );
                                                    }
                                                } catch (error) {
                                                    console.error(error);
                                                }
                                            }}
                                        >
                                            <option value="">Sucursal</option>
                                            {#each branchList as branch}
                                                {#if branch.idsucursal != null}
                                                    <option
                                                        value={branch.idsucursal}
                                                        >{branch.nombre}</option
                                                    >
                                                {/if}
                                            {/each}
                                        </select>

                                        <svg class="icon"
                                            ><use
                                                xlink:href="/assets/img/icons/symbol-defs.svg#icon-angle-left"
                                            ></use></svg
                                        >
                                    </div>
                                </div>
                                {#if isLoadingStock && showLoaderStock}
                                    <div class="d-flex justify-content-center">
                                        <Preloader />
                                    </div>
                                {:else if showLoaderStock && storeStock === 'Error fetching stock'}
                                    <div
                                        class="d-flex justify-content-center m-t-5"
                                    >
                                        <p class="text-error text-center m-b-0">
                                            Error al obtener disponibilidad de
                                            sucursal
                                        </p>
                                    </div>
                                {:else if selectedBranchStock == 0 || selectedBranchStock === null || selectedBranchStock === undefined}
                                    <div
                                        class="d-flex justify-content-center m-t-5"
                                    >
                                        <p class="text-error text-center m-b-0">
                                            El kit de instalación no está
                                            disponible en esta sucursal, por
                                            favor seleccione otra.
                                        </p>
                                    </div>
                                {/if}
                                {#if branchList <= 0 && !isLoadingStores}
                                    <div
                                        class="d-flex justify-content-center m-t-5"
                                    >
                                        <p class="text-error text-center m-b-0">
                                            No se encontraron sucursales cerca,
                                            utiliza la opción de entrega a
                                            domicilio.
                                        </p>
                                    </div>
                                {/if}
                            </div>
                        {/if}
                        {#if showAddressFields || $store.requestedServices.deliveryType === 'DOMICILIO'}
                            <p class="fw-semibold m-b-10 m-t-16">
                                Dirección de envío
                            </p>
                            <p>
                                Esta dirección corresponde a la misma ubicación
                                que indicaste al iniciar tu contratación
                            </p>
                            <div class="pure-g align-items-center m-b-20">
                                <div class="pure-u-1 pure-u-sm-1-3">
                                    <div
                                        class="ctrl-holder m-b-20 {fields.street
                                            .error
                                            ? 'error'
                                            : ''}"
                                    >
                                        <label
                                            for="street"
                                            class="placeholder placeholder-filled disabled"
                                            >Calle</label
                                        >
                                        <input
                                            type="text"
                                            readonly={$store.requestedAddress
                                                .addressId !== ''}
                                            name="street"
                                            id="street"
                                            required
                                            disabled={true}
                                            on:input={() => valField('street')}
                                            bind:value={
                                                $store.requestedAddress.street
                                            }
                                        />
                                        {#if fields.street.error}
                                            <label class="error" for="street"
                                                >{fields.street
                                                    .errorMessage}</label
                                            >
                                        {/if}
                                    </div>
                                </div>
                                <div
                                    class="pure-u-1-2 pure-u-sm-1-3 pure-u-md-1-6"
                                >
                                    <div
                                        class="ctrl-holder m-b-20 {fields
                                            .externalNumber.error
                                            ? 'error'
                                            : ''}"
                                    >
                                        <label
                                            for="externalNumber"
                                            class="placeholder placeholder-filled disabled"
                                            >No. Ext</label
                                        >
                                        <input
                                            type="text"
                                            name="externalNumber"
                                            disabled={true}
                                            id="externalNumber"
                                            required
                                            bind:value={
                                                $store.requestedAddress
                                                    .externalNumber
                                            }
                                            on:input={() =>
                                                valField('externalNumber')}
                                        />
                                        {#if fields.externalNumber.error}
                                            <label
                                                class="error"
                                                for="externalNumber"
                                                >{fields.externalNumber
                                                    .errorMessage}</label
                                            >
                                        {/if}
                                    </div>
                                </div>
                                <div
                                    class="pure-u-1-2 pure-u-sm-1-3 pure-u-md-1-6"
                                >
                                    <div
                                        class="ctrl-holder m-b-20 {fields
                                            .internalNumber.error
                                            ? 'error'
                                            : ''}"
                                    >
                                        <label
                                            for="internalNumber"
                                            class="placeholder placeholder-filled disabled"
                                            >No. Int</label
                                        >
                                        <input
                                            type="text"
                                            name="internalNumber"
                                            disabled={true}
                                            id="internalNumber"
                                            bind:value={
                                                $store.requestedAddress
                                                    .internalNumber
                                            }
                                            on:input={() =>
                                                valField('internalNumber')}
                                        />
                                        {#if fields.internalNumber.error}
                                            <label
                                                class="error"
                                                for="internalNumber"
                                                >{fields.internalNumber
                                                    .errorMessage}</label
                                            >
                                        {/if}
                                    </div>
                                </div>
                                <div class="pure-u-1 pure-u-sm-1-3">
                                    <div class="ctrl-holder m-b-20">
                                        <label
                                            for="zipCode"
                                            class="placeholder placeholder-filled disabled"
                                            >Código postal</label
                                        >
                                        <input
                                            type="text"
                                            readonly="true"
                                            disabled={true}
                                            name="postalCode"
                                            id="postalCode"
                                            required
                                            bind:value={
                                                $store.requestedAddress
                                                    .postalCode
                                            }
                                        />
                                    </div>
                                </div>
                                <div
                                    class="pure-u-1 pure-u-sm-1-2 pure-u-lg-1-3"
                                >
                                    <div
                                        class="ctrl-holder m-b-20 {fields.suburb
                                            .error
                                            ? 'error'
                                            : ''}"
                                    >
                                        <label
                                            for="suburb"
                                            class="placeholder placeholder-filled disabled"
                                            >Colonia</label
                                        >
                                        <input
                                            type="text"
                                            name="suburb"
                                            disabled={true}
                                            id="suburb"
                                            required
                                            bind:value={
                                                $store.requestedAddress.suburb
                                            }
                                            on:input={() => valField('suburb')}
                                        />
                                        {#if fields.suburb.error}
                                            <label class="error" for="suburb"
                                                >{fields.suburb
                                                    .errorMessage}</label
                                            >
                                        {/if}
                                    </div>
                                </div>
                                <div
                                    class="pure-u-1 pure-u-sm-1-2 pure-u-lg-1-3"
                                >
                                    <div
                                        class="ctrl-holder m-b-20 {fields.state
                                            .error
                                            ? 'error'
                                            : ''}"
                                    >
                                        <label
                                            for="state"
                                            class="placeholder placeholder-filled disabled"
                                            >Estado</label
                                        >
                                        <input
                                            type="text"
                                            name="state"
                                            disabled={true}
                                            id="state"
                                            required
                                            bind:value={
                                                $store.requestedAddress.state
                                            }
                                            on:input={() => valField('state')}
                                        />
                                        {#if fields.state.error}
                                            <label class="error" for="state"
                                                >{fields.state
                                                    .errorMessage}</label
                                            >
                                        {/if}
                                    </div>
                                </div>
                                <div
                                    class="pure-u-1 pure-u-sm-1-2 pure-u-lg-1-3"
                                >
                                    <div
                                        class="ctrl-holder m-b-20 {fields.city
                                            .error
                                            ? 'error'
                                            : ''}"
                                    >
                                        <label
                                            for="city"
                                            class="placeholder placeholder-filled disabled"
                                            >Delegación o municipio</label
                                        >
                                        <input
                                            type="text"
                                            name="city"
                                            disabled={true}
                                            id="city"
                                            required
                                            bind:value={
                                                $store.requestedAddress.city
                                            }
                                            on:input={() => valField('city')}
                                        />
                                        {#if fields.city.error}
                                            <label class="error" for="city"
                                                >{fields.city
                                                    .errorMessage}</label
                                            >
                                        {/if}
                                    </div>
                                </div>
                            </div>
                            <p class="fw-semibold m-b-10 m-t-16">Referencias</p>
                            <div class="pure-g align-items-center">
                                <div class="pure-u-1 pure-u-sm-1-2">
                                    <div
                                        class="ctrl-holder m-b-20 {fields
                                            .betweenStreets1.error === true
                                            ? 'error'
                                            : ''}"
                                    >
                                        <label
                                            for="betweenStreets1"
                                            class="placeholder placeholder-filled disabled"
                                            >Calle 1</label
                                        >
                                        <input
                                            type="text"
                                            name="betweenStreets1"
                                            id="betweenStreets1"
                                            disabled={processAdvanced}
                                            bind:value={
                                                $store.requestedAddress
                                                    .betweenStreets1
                                            }
                                            on:input={() =>
                                                valField('betweenStreets1')}
                                        />
                                        {#if fields.betweenStreets1.error}
                                            <label
                                                class="error"
                                                for="betweenStreets1"
                                                >{fields.betweenStreets1
                                                    .errorMessage}</label
                                            >
                                        {/if}
                                    </div>
                                </div>
                                <div class="pure-u-1 pure-u-sm-1-2">
                                    <div
                                        class="ctrl-holder m-b-20 {fields
                                            .betweenStreets2.error
                                            ? 'error'
                                            : ''}"
                                    >
                                        <label
                                            for="betweenStreets2"
                                            class="placeholder placeholder-filled disabled"
                                            >Calle 2</label
                                        >
                                        <input
                                            type="text"
                                            name="betweenStreets2"
                                            id="betweenStreets2"
                                            required
                                            disabled={processAdvanced}
                                            bind:value={
                                                $store.requestedAddress
                                                    .betweenStreets2
                                            }
                                            on:input={() =>
                                                valField('betweenStreets2')}
                                        />
                                        {#if fields.betweenStreets2.error}
                                            <label
                                                class="error"
                                                for="betweenStreets2"
                                                >{fields.betweenStreets2
                                                    .errorMessage}</label
                                            >
                                        {/if}
                                    </div>
                                </div>
                                <div class="pure-u-1 pure-u-sm-1-1">
                                    <div
                                        class="ctrl-holder {fields
                                            .addressReference.error
                                            ? 'error'
                                            : ''}"
                                    >
                                        <label
                                            for="addressReference"
                                            class="placeholder placeholder-filled disabled"
                                            >Referencia</label
                                        >
                                        <input
                                            type="text"
                                            name="addressReference"
                                            id="addressReference"
                                            required
                                            disabled={processAdvanced}
                                            on:input={() =>
                                                valField('addressReference')}
                                            bind:value={
                                                $store.requestedAddress
                                                    .addressReference
                                            }
                                        />
                                        {#if fields.addressReference.error}
                                            <label
                                                class="error"
                                                for="addressReference"
                                                >{fields.addressReference
                                                    .errorMessage}</label
                                            >
                                        {/if}
                                    </div>
                                </div>
                            </div>
                        {/if}
                        <div class="d-flex flex-wrap asistence">
                            <div>
                                <p class="fw-semibold m-b-25">
                                    Asistencia técnica
                                </p>
                                <p>
                                    Un técnico especializado llevará tu equipo a
                                    domicilio, lo instalará y lo configurará por
                                    ti.
                                </p>
                                <button
                                    class="button-address m-b-15 {$store
                                        .requestedServices.deliveryType ===
                                    'TECNICO'
                                        ? 'selected'
                                        : ''}"
                                    disabled={processAdvanced}
                                    on:click={() => {
                                        isDeliveryDomiciliary = false;
                                        isDeliveryBranch = false;
                                        isDeliveryTechnical = true;
                                        setDeliveryType('TECNICO');
                                    }}>entrega por un técnico</button
                                >
                            </div>
                        </div>
                        {#if showTechnicianAddressFields || $store.requestedServices.deliveryType === 'TECNICO'}
                            <p class="fw-semibold m-b-10">
                                Dirección de servicio
                            </p>
                            <div class="pure-g align-items-center m-b-20">
                                <div class="pure-u-1 pure-u-sm-1-3">
                                    <div
                                        class="ctrl-holder m-b-20 {fields.street
                                            .error
                                            ? 'error'
                                            : ''}"
                                    >
                                        <label
                                            for="street"
                                            class="placeholder placeholder-filled disabled"
                                            >Calle</label
                                        >
                                        <input
                                            type="text"
                                            readonly={$store.requestedAddress
                                                .addressId !== ''}
                                            name="street"
                                            id="street"
                                            required
                                            disabled={true}
                                            on:input={() => valField('street')}
                                            bind:value={
                                                $store.requestedAddress.street
                                            }
                                        />
                                        {#if fields.street.error}
                                            <label class="error" for="street"
                                                >{fields.street
                                                    .errorMessage}</label
                                            >
                                        {/if}
                                    </div>
                                </div>
                                <div
                                    class="pure-u-1-2 pure-u-sm-1-3 pure-u-md-1-6"
                                >
                                    <div
                                        class="ctrl-holder m-b-20 {fields
                                            .externalNumber.error
                                            ? 'error'
                                            : ''}"
                                    >
                                        <label
                                            for="externalNumber"
                                            class="placeholder placeholder-filled disabled"
                                            >No. Ext</label
                                        >
                                        <input
                                            type="text"
                                            name="externalNumber"
                                            disabled={true}
                                            id="externalNumber"
                                            required
                                            bind:value={
                                                $store.requestedAddress
                                                    .externalNumber
                                            }
                                            on:input={() =>
                                                valField('externalNumber')}
                                        />
                                        {#if fields.externalNumber.error}
                                            <label
                                                class="error"
                                                for="externalNumber"
                                                >{fields.externalNumber
                                                    .errorMessage}</label
                                            >
                                        {/if}
                                    </div>
                                </div>
                                <div
                                    class="pure-u-1-2 pure-u-sm-1-3 pure-u-md-1-6"
                                >
                                    <div
                                        class="ctrl-holder m-b-20 {fields
                                            .internalNumber.error
                                            ? 'error'
                                            : ''}"
                                    >
                                        <label
                                            for="internalNumber"
                                            class="placeholder placeholder-filled disabled"
                                            >No. Int</label
                                        >
                                        <input
                                            type="text"
                                            name="internalNumber"
                                            disabled={true}
                                            id="internalNumber"
                                            bind:value={
                                                $store.requestedAddress
                                                    .internalNumber
                                            }
                                            on:input={() =>
                                                valField('internalNumber')}
                                        />
                                        {#if fields.internalNumber.error}
                                            <label
                                                class="error"
                                                for="internalNumber"
                                                >{fields.internalNumber
                                                    .errorMessage}</label
                                            >
                                        {/if}
                                    </div>
                                </div>
                                <div class="pure-u-1 pure-u-sm-1-3">
                                    <div class="ctrl-holder m-b-20">
                                        <label
                                            for="zipCode"
                                            class="placeholder placeholder-filled disabled"
                                            >Código postal</label
                                        >
                                        <input
                                            type="text"
                                            readonly="true"
                                            disabled={true}
                                            name="postalCode"
                                            id="postalCode"
                                            required
                                            bind:value={
                                                $store.requestedAddress
                                                    .postalCode
                                            }
                                        />
                                    </div>
                                </div>
                                <div
                                    class="pure-u-1 pure-u-sm-1-2 pure-u-lg-1-3"
                                >
                                    <div
                                        class="ctrl-holder m-b-20 {fields.suburb
                                            .error
                                            ? 'error'
                                            : ''}"
                                    >
                                        <label
                                            for="suburb"
                                            class="placeholder placeholder-filled disabled"
                                            >Colonia</label
                                        >
                                        <input
                                            type="text"
                                            name="suburb"
                                            disabled={true}
                                            id="suburb"
                                            required
                                            bind:value={
                                                $store.requestedAddress.suburb
                                            }
                                            on:input={() => valField('suburb')}
                                        />
                                        {#if fields.suburb.error}
                                            <label class="error" for="suburb"
                                                >{fields.suburb
                                                    .errorMessage}</label
                                            >
                                        {/if}
                                    </div>
                                </div>
                                <div
                                    class="pure-u-1 pure-u-sm-1-2 pure-u-lg-1-3"
                                >
                                    <div
                                        class="ctrl-holder m-b-20 {fields.state
                                            .error
                                            ? 'error'
                                            : ''}"
                                    >
                                        <label
                                            for="state"
                                            class="placeholder placeholder-filled disabled"
                                            >Estado</label
                                        >
                                        <input
                                            type="text"
                                            name="state"
                                            disabled={true}
                                            id="state"
                                            required
                                            bind:value={
                                                $store.requestedAddress.state
                                            }
                                            on:input={() => valField('state')}
                                        />
                                        {#if fields.state.error}
                                            <label class="error" for="state"
                                                >{fields.state
                                                    .errorMessage}</label
                                            >
                                        {/if}
                                    </div>
                                </div>
                                <div
                                    class="pure-u-1 pure-u-sm-1-2 pure-u-lg-1-3"
                                >
                                    <div
                                        class="ctrl-holder m-b-20 {fields.city
                                            .error
                                            ? 'error'
                                            : ''}"
                                    >
                                        <label
                                            for="city"
                                            class="placeholder placeholder-filled disabled"
                                            >Delegación o municipio</label
                                        >
                                        <input
                                            type="text"
                                            name="city"
                                            disabled={true}
                                            id="city"
                                            required
                                            bind:value={
                                                $store.requestedAddress.city
                                            }
                                            on:input={() => valField('city')}
                                        />
                                        {#if fields.city.error}
                                            <label class="error" for="city"
                                                >{fields.city
                                                    .errorMessage}</label
                                            >
                                        {/if}
                                    </div>
                                </div>
                            </div>
                            <p class="fw-semibold m-b-10 m-t-16">Referencias</p>
                            <div class="pure-g align-items-center m-b-20">
                                <div class="pure-u-1 pure-u-sm-1-2">
                                    <div
                                        class="ctrl-holder m-b-20 {fields
                                            .betweenStreets1.error === true
                                            ? 'error'
                                            : ''}"
                                    >
                                        <label
                                            for="betweenStreets1"
                                            class="placeholder placeholder-filled disabled"
                                            >Calle 1</label
                                        >
                                        <input
                                            type="text"
                                            name="betweenStreets1"
                                            id="betweenStreets1"
                                            disabled={processAdvanced}
                                            bind:value={
                                                $store.requestedAddress
                                                    .betweenStreets1
                                            }
                                            on:input={() =>
                                                valField('betweenStreets1')}
                                        />
                                        {#if fields.betweenStreets1.error}
                                            <label
                                                class="error"
                                                for="betweenStreets1"
                                                >{fields.betweenStreets1
                                                    .errorMessage}</label
                                            >
                                        {/if}
                                    </div>
                                </div>
                                <div class="pure-u-1 pure-u-sm-1-2">
                                    <div
                                        class="ctrl-holder m-b-20 {fields
                                            .betweenStreets2.error
                                            ? 'error'
                                            : ''}"
                                    >
                                        <label
                                            for="betweenStreets2"
                                            class="placeholder placeholder-filled disabled"
                                            >Calle 2</label
                                        >
                                        <input
                                            type="text"
                                            name="betweenStreets2"
                                            id="betweenStreets2"
                                            required
                                            disabled={processAdvanced}
                                            bind:value={
                                                $store.requestedAddress
                                                    .betweenStreets2
                                            }
                                            on:input={() =>
                                                valField('betweenStreets2')}
                                        />
                                        {#if fields.betweenStreets2.error}
                                            <label
                                                class="error"
                                                for="betweenStreets2"
                                                >{fields.betweenStreets2
                                                    .errorMessage}</label
                                            >
                                        {/if}
                                    </div>
                                </div>
                                <div class="pure-u-1 pure-u-sm-1-1">
                                    <div
                                        class="ctrl-holder m-b-20 {fields
                                            .addressReference.error
                                            ? 'error'
                                            : ''}"
                                    >
                                        <label
                                            for="addressReference"
                                            class="placeholder placeholder-filled disabled"
                                            >Referencia</label
                                        >
                                        <input
                                            type="text"
                                            name="addressReference"
                                            id="addressReference"
                                            required
                                            disabled={processAdvanced}
                                            on:input={() =>
                                                valField('addressReference')}
                                            bind:value={
                                                $store.requestedAddress
                                                    .addressReference
                                            }
                                            on:change={() =>
                                                valField('addressReference')}
                                        />
                                        {#if fields.addressReference.error}
                                            <label
                                                class="error"
                                                for="addressReference"
                                                >{fields.addressReference
                                                    .errorMessage}</label
                                            >
                                        {/if}
                                    </div>
                                </div>
                            </div>
                        {/if}
                    {/if}
                </div>
                <div class="pure-g align-items-center m-b-30">
                    <div class="pure-u-2-3">
                        <p class="m-b-0">¿Deseas facturar?</p>
                    </div>
                    <div class="pure-u-1-3 text-right">
                        <span class="checkbox-switch" style={tabsStyle}>
                            <input
                                type="checkbox"
                                name="datos_facturar"
                                id="datos_facturar"
                                disabled={processAdvanced}
                                bind:checked={$store.personalDetails.billing}
                                on:change={facturar}
                            />
                            <label for="datos_facturar" />
                        </span>
                    </div>
                </div>
                {#if $store.personalDetails.billing}
                    <hr class="m-b-20" />
                    <div class="pure-g align-items-center m-b-20">
                        <div class="pure-u-1 pure-u-sm-1-3">
                            <div
                                class="ctrl-holder m-b-20 {fields.rfc.error
                                    ? 'error'
                                    : ''}"
                            >
                                <label for="rfc" class="placeholder">RFC</label>
                                <input
                                    type="text"
                                    name="rfc"
                                    id="rfc"
                                    required
                                    bind:value={$store.personalDetails.rfc}
                                    on:input={() => valField('rfc')}
                                    style="text-transform: uppercase;"
                                />
                                {#if fields.rfc.error}
                                    <label class="error" for="rfc"
                                        >{fields.rfc.errorMessage}</label
                                    >
                                {/if}
                            </div>
                        </div>
                        <div class="pure-u-1 pure-u-sm-1-3">
                            <div
                                class="select-holder m-b-20 {fields.codigoCfdi
                                    .error
                                    ? 'error'
                                    : ''}"
                            >
                                <select
                                    name="codigoCfdi"
                                    id="codigoCfdi"
                                    required
                                    bind:value={
                                        $store.personalDetails.codigoCfdi
                                    }
                                    on:change={() => valField('codigoCfdi')}
                                >
                                    <option value="">Uso de CFDI</option>
                                    <option
                                        value="G01-Adquisicion de mercancias"
                                        >G01 - Adquisición de mercancias</option
                                    >
                                    <option
                                        value="G02-Devoluciones, descuentos o"
                                        >G02 - Devoluciones, descuentos o
                                        bonificaciones</option
                                    >
                                    <option value="G03-Gastos en general"
                                        >G03 - Gastos en general</option
                                    >
                                    <option value="I01-Construcciones"
                                        >I01 - Construcciones</option
                                    >
                                    <option
                                        value="I02-Mobiliario y equipo de ofi"
                                        >I02 - Mobiliario y equipo de oficina
                                        por inversiones</option
                                    >
                                    <option value="I03-Equipo de transporte"
                                        >I03 - Equipo de transporte</option
                                    >
                                    <option
                                        value="I04-Equipo de computo y acceso"
                                        >I04 - Equipo de computo y accesorios</option
                                    >
                                    <option
                                        value="I05-Dados, troqueles, moldes,"
                                        >I05 - Dados, troqueles, moldes,
                                        matrices y herramental</option
                                    >
                                    <option
                                        value="I06-Comunicaciones telefonicas"
                                        >I06 - Comunicaciones telefónicas</option
                                    >
                                    <option
                                        value="I07-Comunicaciones satelitales"
                                        >I07 - Comunicaciones satelitales</option
                                    >
                                    <option value="I08-Otra maquinaria y equipo"
                                        >I08 - Otra maquinaria y equipo</option
                                    >
                                    <option
                                        value="D01-Honorarios medicos, dental"
                                        >D01 - Honorarios médicos, dentales y
                                        gastos hospitalarios</option
                                    >
                                    <option
                                        value="D02-Gastos medicos por incapac"
                                        >D02 - Gastos médicos por incapacidad o
                                        discapacidad</option
                                    >
                                    <option value="D03-Gastos funerales"
                                        >D03 - Gastos funerales</option
                                    >
                                    <option value="D04-Donativos"
                                        >D04 - Donativos</option
                                    >
                                    <option
                                        value="D05-Intereses reales efectivam"
                                        >D05 - Intereses reales efectivamente
                                        pagados por créditos hipotecarios (casa
                                        habitación)</option
                                    >
                                    <option
                                        value="D06-Aportaciones voluntarias a"
                                        >D06 - Aportaciones voluntarias al SAT</option
                                    >
                                    <option
                                        value="D07-Primas por seguros de gast"
                                        >D07 - Primas por seguros de gastos
                                        médicos</option
                                    >
                                    <option
                                        value="D08-Gastos de transportacion e"
                                        >D08 - Gastos de transportación escolar
                                        obligatoria</option
                                    >
                                    <option
                                        value="D09-Depositos en cuentas para"
                                        >D09 - Depósitos en cuentas para el
                                        ahorro</option
                                    >
                                    <option
                                        value="D10-Pagos por servicios educat"
                                        >D10 - Pagos por servicios educativos
                                        (colegiaturas)</option
                                    >
                                    <option value="S01-Sin efectos fiscales"
                                        >S01 - Sin efectos fiscales</option
                                    >
                                    <option value="CP01-Pagos"
                                        >CP01 - Pagos</option
                                    >
                                    <option value="CN01-Nomina"
                                        >CN01 - Nómina</option
                                    >
                                </select>
                                <svg class="icon"
                                    ><use
                                        xlink:href="/assets/img/icons/symbol-defs.svg#icon-angle-left"
                                    ></use></svg
                                >
                                {#if fields.codigoCfdi.error}
                                    <label class="error" for="codigoCfdi"
                                        >{fields.codigoCfdi.errorMessage}</label
                                    >
                                {/if}
                            </div>
                        </div>
                        <div class="pure-u-1 pure-u-sm-1-3">
                            <div
                                class="select-holder m-b-20 {fields
                                    .regimenFiscal.error
                                    ? 'error'
                                    : ''}"
                            >
                                <select
                                    name="regimenFiscal"
                                    id="regimenFiscal"
                                    required
                                    bind:value={
                                        $store.personalDetails.regimenFiscal
                                    }
                                    on:change={() => valField('regimenFiscal')}
                                >
                                    <option value="">Régimen fiscal</option>
                                    <option
                                        value="601-General de Ley Personas Mo"
                                        >601 - General de Ley Personas Morales</option
                                    >
                                    <option
                                        value="603-Personas Morales con Fines"
                                        >603 - Personas Morales con Fines no
                                        Lucrativos</option
                                    >
                                    <option
                                        value="605-Sueldos y Salarios e Ingre"
                                        >605 - Sueldos y Salarios e Ingresos
                                        Asimilados a Salarios</option
                                    >
                                    <option value="606-Arrendamiento"
                                        >606 - Arrendamiento</option
                                    >
                                    <option
                                        value="607-Regimen de Enajenacion o A"
                                        >607 - Régimen de Enajenación o
                                        Adquisición de Bienes</option
                                    >
                                    <option value="608-Demas ingresos"
                                        >608 - Demás ingresos</option
                                    >
                                    <option
                                        value="610-Residentes en el Extranjer"
                                        >610 - Residentes en el Extranjero sin
                                        Establecimiento Permanente en México</option
                                    >
                                    <option value="611-Ingresos por Dividendos"
                                        >611 - Ingresos por Dividendos (socios y
                                        accionistas)</option
                                    >
                                    <option
                                        value="612-Personas Fisicas con Activ"
                                        >612 - Personas Físicas con Actividades
                                        Empresariales y Profesionales</option
                                    >
                                    <option value="614-Ingresos por intereses"
                                        >614 - Ingresos por intereses</option
                                    >
                                    <option
                                        value="615-Regimen de los ingresos po"
                                        >615 - Régimen de los ingresos por
                                        obtención de premios</option
                                    >
                                    <option
                                        value="616-Sin obligaciones fiscales"
                                        >616 - Sin obligaciones fiscales</option
                                    >
                                    <option
                                        value="620-Sociedades Cooperativas de"
                                        >620 - Sociedades Cooperativas de
                                        Producción que optan por diferir sus
                                        ingresos</option
                                    >
                                    <option value="621-Incorporacion Fiscal"
                                        >621 - Incorporación Fiscal</option
                                    >
                                    <option
                                        value="622-Actividades Agricolas, Gan"
                                        >622 - Actividades Agrícolas, Ganaderas,
                                        Silvícolas y Pesqueras</option
                                    >
                                    <option
                                        value="623-Opcional para Grupos de So"
                                        >623 - Opcional para Grupos de
                                        Sociedades</option
                                    >
                                    <option value="624-Coordinados"
                                        >624 - Coordinados</option
                                    >
                                    <option
                                        value="625-Regimen de las Actividades"
                                        >625 - Régimen de las Actividades
                                        Empresariales con ingresos a través de
                                        Plataformas Tecnológicas</option
                                    >
                                    <option
                                        value="626-Regimen Simplificado de Co"
                                        >626 - Régimen Simplificado de Confianza</option
                                    >
                                </select>
                                <svg class="icon"
                                    ><use
                                        xlink:href="/assets/img/icons/symbol-defs.svg#icon-angle-left"
                                    ></use></svg
                                >
                                {#if fields.regimenFiscal.error}
                                    <label class="error" for="regimenFiscal"
                                        >{fields.regimenFiscal
                                            .errorMessage}</label
                                    >
                                {/if}
                            </div>
                        </div>
                        <div class="pure-g align-items-center m-b-20">
                            <div class="pure-u-2-3">
                                <p class="m-b-0">
                                    ¿Deseas facturar con otra dirección?
                                </p>
                            </div>
                            <div class="pure-u-1-3 text-right">
                                <span class="checkbox-switch" style={tabsStyle}>
                                    <input
                                        type="checkbox"
                                        name="facturar_otradireccion"
                                        id="facturar_otradireccion"
                                        bind:checked={
                                            $store.requestedAddress.billing
                                        }
                                        on:change={facturaDireccion}
                                    />
                                    <label for="facturar_otradireccion" />
                                </span>
                            </div>
                        </div>
                    </div>
                    {#if $store.requestedAddress.billing}
                        <hr class="m-b-20" />
                        <div class="pure-g align-items-center m-b-20">
                            <div class="pure-u-1 pure-u-sm-2-3">
                                <div
                                    class="ctrl-holder m-b-20 {fields
                                        .billingStreet.error
                                        ? 'error'
                                        : ''}"
                                >
                                    <label
                                        for="billingStreet"
                                        class="placeholder">Calle</label
                                    >
                                    <input
                                        type="text"
                                        name="billingStreet"
                                        id="billingStreet"
                                        required
                                        bind:value={
                                            $store.requestedAddress
                                                .billingStreet
                                        }
                                        on:input={() =>
                                            valField('billingStreet')}
                                    />
                                    {#if fields.billingStreet.error}
                                        <label class="error" for="billingStreet"
                                            >{fields.billingStreet
                                                .errorMessage}</label
                                        >
                                    {/if}
                                </div>
                            </div>
                            <div class="pure-u-1-2 pure-u-sm-1-6">
                                <div
                                    class="ctrl-holder m-b-20 {fields
                                        .billingExteriorNumber.error
                                        ? 'error'
                                        : ''}"
                                >
                                    <label
                                        for="billingExteriorNumber"
                                        class="placeholder">No. Ext</label
                                    >
                                    <input
                                        type="text"
                                        name="billingExteriorNumber"
                                        id="billingExteriorNumber"
                                        required
                                        bind:value={
                                            $store.requestedAddress
                                                .billingExteriorNumber
                                        }
                                        on:input={() =>
                                            valField('billingExteriorNumber')}
                                    />
                                    {#if fields.billingExteriorNumber.error}
                                        <label
                                            class="error"
                                            for="billingExteriorNumber"
                                            >{fields.billingExteriorNumber
                                                .errorMessage}</label
                                        >
                                    {/if}
                                </div>
                            </div>
                            <div class="pure-u-1-2 pure-u-sm-1-6">
                                <div class="ctrl-holder m-b-20">
                                    <label
                                        for="billingInteriorNumber"
                                        class="placeholder">No. Int</label
                                    >
                                    <input
                                        type="text"
                                        name="billingInteriorNumber"
                                        id="billingInteriorNumber"
                                        bind:value={
                                            $store.requestedAddress
                                                .billingInteriorNumber
                                        }
                                        on:input={() =>
                                            valField('billingInteriorNumber')}
                                    />
                                    {#if fields.billingInteriorNumber.error}
                                        <label
                                            class="error"
                                            for="billingInteriorNumber"
                                            >{fields.billingInteriorNumber
                                                .errorMessage}</label
                                        >
                                    {/if}
                                </div>
                            </div>
                            <div class="pure-u-1 pure-u-sm-1-2">
                                <div
                                    class="ctrl-holder m-b-20 {fields
                                        .billingSettlement.error
                                        ? 'error'
                                        : ''}"
                                >
                                    <label
                                        for="billingSettlement"
                                        class="placeholder">Colonia</label
                                    >
                                    <input
                                        type="text"
                                        name="billingSettlement"
                                        id="billingSettlement"
                                        required
                                        bind:value={
                                            $store.requestedAddress
                                                .billingSettlement
                                        }
                                        on:input={() =>
                                            valField('billingSettlement')}
                                    />
                                    {#if fields.billingSettlement.error}
                                        <label
                                            class="error"
                                            for="billingSettlement"
                                            >{fields.billingSettlement
                                                .errorMessage}</label
                                        >
                                    {/if}
                                </div>
                            </div>
                            <div class="pure-u-1 pure-u-sm-1-2">
                                <div
                                    class="ctrl-holder m-b-20 {fields
                                        .billingState.error
                                        ? 'error'
                                        : ''}"
                                >
                                    <label
                                        for="billingState"
                                        class="placeholder">Estado</label
                                    >
                                    <input
                                        type="text"
                                        name="billingState"
                                        id="billingState"
                                        required
                                        bind:value={
                                            $store.requestedAddress.billingState
                                        }
                                        on:input={() =>
                                            valField('billingState')}
                                    />
                                    {#if fields.billingState.error}
                                        <label class="error" for="billingState"
                                            >{fields.billingState
                                                .errorMessage}</label
                                        >
                                    {/if}
                                </div>
                            </div>
                            <div class="pure-u-1 pure-u-sm-1-2">
                                <div
                                    class="ctrl-holder m-b-20 {fields
                                        .billingCity.error
                                        ? 'error'
                                        : ''}"
                                >
                                    <label for="billingCity" class="placeholder"
                                        >Delegación o municipio</label
                                    >
                                    <input
                                        type="text"
                                        name="billingCity"
                                        id="billingCity"
                                        required
                                        bind:value={
                                            $store.requestedAddress.billingCity
                                        }
                                        on:input={() => valField('billingCity')}
                                    />
                                    {#if fields.billingCity.error}
                                        <label class="error" for="billingCity"
                                            >{fields.billingCity
                                                .errorMessage}</label
                                        >
                                    {/if}
                                </div>
                            </div>
                            <div class="pure-u-1 pure-u-sm-1-2">
                                <div
                                    class="ctrl-holder m-b-20 {fields
                                        .billingPostalCode.error
                                        ? 'error'
                                        : ''}"
                                >
                                    <label
                                        for="billingPostalCode"
                                        class="placeholder">Código postal</label
                                    >
                                    <input
                                        type="text"
                                        name="billingPostalCode"
                                        id="billingPostalCode"
                                        required
                                        bind:value={
                                            $store.requestedAddress
                                                .billingPostalCode
                                        }
                                        on:input={() =>
                                            valField('billingPostalCode')}
                                    />
                                    {#if fields.billingPostalCode.error}
                                        <label
                                            class="error"
                                            for="billingPostalCode"
                                            >{fields.billingPostalCode
                                                .errorMessage}</label
                                        >
                                    {/if}
                                </div>
                            </div>
                        </div>
                    {/if}
                {/if}
                <div class="d-flex align-items-center justify-content-between">
                    <a
                        href="#/"
                        class="back-link"
                        on:click={() => backHandler()}
                    >
                        <svg class="icon" aria-hidden="true"
                            ><use
                                xlink:href="/assets/img/icons/symbol-defs.svg#icon-arrow-left"
                            /></svg
                        >
                        <span class="fw-semibold">atrás</span>
                    </a>
                    <div>
                        <a
                            href="#/"
                            class="pure__button button-hide {isSky
                                ? 'pure__button--blue-dark'
                                : 'pure__button--base'} {isNextStepDisabled ||
                            !validContinue
                                ? 'pure__button--disabled'
                                : 'pure__button--base'}"
                            on:click|preventDefault={() =>
                                !isNextStepDisabled && valContent()}
                            >Continuar</a
                        >
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<Modal ident="modalError" title="Lo sentimos" message={messageInfoError} />
<Modal ident="modalError" title="Lo sentimos" message={messageInfoError} />

<style>
    .hide {
        display: none;
    }
    input:disabled {
        background: #f5f6f8;
    }
</style>
